import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { FaArrowRight, FaArrowLeft } from "react-icons/fa";

const Carousel = ({ items = [], interval = 3000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Ordena os itens e seleciona os primeiros 5
  const qtdItems = items
    .sort((a, b) => b.ID - a.ID) // Ordena por ID em ordem decrescente
    .slice(0, 5); // Pega os 5 primeiros itens

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? qtdItems.length - 1 : prevIndex - 1,
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === qtdItems.length - 1 ? 0 : prevIndex + 1,
    );
  };

  useEffect(() => {
    const autoSlide = setInterval(() => handleNext(), interval);
    return () => clearInterval(autoSlide); // Limpa o intervalo ao desmontar
  }, []);

  return (
    <div className="relative w-full h-72 md:h-80 lg:h-96 max-w-7xl mx-auto overflow-hidden rounded-2xl shadow-lg">
      {/* Container de Slides */}
      <div
        className="flex transition-transform duration-500 ease-in-out"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {qtdItems.map((item) => (
          <Link
            key={item.ID} // Usa `id` do JSON como chave única
            to={`/noticias/${item.ID}`} // Define o link para a página da notícia
            className="flex-shrink-0 w-full h-96 bg-cover bg-center flex flex-col justify-end"
          >
            <img src={item.file.url} alt="Imagem da postagem de notícia" className="object-cover" />
            {/* Barra Azul com Título */}
            <div className="w-full bg-blue-950 h-48 md:h-36 lg:h-20 flex items-center justify-center">
              <p className="text-lg mb-32 md:mb-24 lg:mb-8 font-semibold text-white text-center px-4">
                {item.title}
              </p>
            </div>
          </Link>
        ))}
      </div>

      {/* Botões de Navegação */}
      <button
        className="absolute left-2 top-1/2 transform -translate-y-1/2 text-white bg-gray-700 bg-opacity-50 hover:bg-opacity-75 rounded-full p-2 focus:outline-none"
        onClick={handlePrevious}
      >
        <FaArrowLeft />
      </button>
      <button
        className="absolute right-2 top-1/2 transform -translate-y-1/2 text-white bg-gray-700 bg-opacity-50 hover:bg-opacity-75 rounded-full p-2 focus:outline-none"
        onClick={handleNext}
      >
        <FaArrowRight />
      </button>

      {/* Indicadores de Posição */}
      <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2">
        {qtdItems.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-3 h-3 rounded-full ${
              index === currentIndex ? "bg-white" : "bg-gray-400"
            }`}
          ></button>
        ))}
      </div>
    </div>
  );
};

export default Carousel;
